import React, { Component } from "react";
import PropTypes from "prop-types";
import { MdExpandMore, MdTv, MdErrorOutline, MdMenuBook, MdFullscreen } from "react-icons/md";

import { connect } from "react-redux";

import { Link } from "react-router-dom";

// reactstrap
import { Row, Col, Dropdown } from "react-bootstrap";

// Import menuDropdown
//import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown"
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";

import logo from "../../../assets/images/logo-sm-light.png";
import logoLight from "../../../assets/images/logo-light.png";
//import logoLightSvg from  "../../../assets/images/logo-light.svg"
import logoDark from "../../../assets/images/logo-dark.png";

// import images
// import github from  "../../../assets/images/brands/github.png"
// import bitbucket from  "../../../assets/images/brands/bitbucket.png"
// import dribbble from  "../../../assets/images/brands/dribbble.png"
// import dropbox from  "../../../assets/images/brands/dropbox.png"
// import mail_chimp from  "../../../assets/images/brands/mail_chimp.png"
// import slack from  "../../../assets/images/brands/slack.png"

// Redux Store
//import { toggleRightSidebar } from "../../store/actions"

//i18n
//import { withTranslation } from "react-i18next"

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = { isSearch: false };
    this.toggleMenu = this.toggleMenu.bind(this);
    //this.toggleRightbar = this.toggleRightbar.bind(this)
    this.toggleFullscreen = this.toggleFullscreen.bind(this);
    this.toggleSearch = this.toggleSearch.bind(this);
  }

  toggleSearch = () => {
    this.setState({ isSearch: !this.state.isSearch });
  };
  /**
   * Toggle sidebar
   */
  toggleMenu() {
    this.props.openLeftMenuCallBack();
  }

  /**
   * Toggles the sidebar
   */
  // toggleRightbar() {
  //   this.props.toggleRightSidebar()
  // }

  toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        <header id="page-topbar">
          <div className="navbar-header">
            <div className="d-flex">
              <div className="navbar-brand-box">
                <Link to="/" className="logo logo-dark">
                  <span className="logo-sm">
                    <img src={logo} alt="" height="22" />
                  </span>
                  <span className="logo-lg">
                    <img src={logoDark} alt="" height="50" />
                  </span>
                </Link>

                <Link to="/" className="logo logo-light">
                  <span className="logo-sm">
                    <img src={logoLight} alt="" height="50" />
                  </span>
                  <span className="logo-lg">
                    <img src={logoLight} alt="" height="50" />
                  </span>
                </Link>
              </div>

              {/* <button
                type="button"
                className="btn btn-sm px-3 font-size-16 d-lg-none header-item waves-effect waves-light"
                data-toggle="collapse"
                onClick={this.toggleMenu}
                data-target="#topnav-menu-content"
              >
                <i className="fa fa-fw fa-bars"/>
              </button> */}

              {/* <form className="app-search d-none d-lg-block ml-3">
                <div className="position-relative">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                  />
                  <span className="ic_extra_small ic-search"/>
                </div>
              </form> */}
            </div>

            <div className="d-flex">
              <div className="dropdown d-inline-block d-lg-none ml-2">
                <button
                  type="button"
                  className="btn header-item noti-icon waves-effect"
                  id="page-header-search-dropdown"
                  onClick={() => {
                    this.setState({ isSearch: !this.state.isSearch });
                  }}
                >
                  <i className="ic ic-magnify" />
                </button>
                <div
                  className={
                    this.state.isSearch
                      ? "dropdown-menu dropdown-menu-lg dropdown-menu-right p-0 show"
                      : "dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
                  }
                  aria-labelledby="page-header-search-dropdown"
                >
                  <form className="p-3">
                    <div className="form-group m-0">
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder={"Search ..."}
                          aria-label="Recipient's username"
                        />
                        <div className="input-group-append">
                          <button className="btn btn-primary" type="submit">
                            <i className="ic ic-magnify" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <Dropdown className="dropdown-mega ml-2" show={this.state.megaMenuDrp}>
                <Dropdown.Toggle
                  className="btn header-item waves-effect bg-transperant"
                  onClick={() => {
                    this.setState({ megaMenuDrp: !this.state.megaMenuDrp });
                  }}
                >
                  {"Dashboard"} <MdExpandMore />
                </Dropdown.Toggle>
                <Dropdown.Menu
                  className="dropdown-megamenu"
                  onClick={() => {
                    this.setState({ megaMenuDrp: !this.state.megaMenuDrp });
                  }}
                >
                  <Row>
                    <Col md={4} className="link mb-2">
                      <Link to="/dashboard">
                        <div>
                          <MdTv className="ic_medium" />
                          <span className="h2 ml-2 mt-1 d-inline-block position-absolute">
                            {"Dashboard"}
                          </span>
                        </div>
                        <div className="h6 font-size-12 mt-2">Manage sensors.</div>
                      </Link>
                    </Col>

                    <Col md={4} className="link mb-2">
                      <Link to="/alerts">
                        <div>
                          <MdErrorOutline className="ic_medium" />
                          <span className="h2 ml-2 mt-1 d-inline-block position-absolute">
                            {"Alert"}
                          </span>
                        </div>
                        <div className="h6 font-size-12 mt-2">
                          Manage all alerts and its confugrations.
                        </div>
                      </Link>
                    </Col>

                    <Col md={4} className="link mb-2">
                      <Link to="/reports">
                        <div>
                          <MdMenuBook className="ic_medium" />
                          <span className="h2 ml-2 mt-1 d-inline-block position-absolute">
                            {"Reports"}
                          </span>
                        </div>
                        <div className="h6 font-size-12 mt-2">
                          Download report and its configurations.
                        </div>
                      </Link>
                    </Col>
                  </Row>
                </Dropdown.Menu>
              </Dropdown>

              {/* <Dropdown
                className="d-none d-lg-inline-block ml-1"
                isOpen={this.state.socialDrp}
                toggle={() => {
                  this.setState({ socialDrp: !this.state.socialDrp })
                }}
              >
                <Dropdown.Toggle
                  className="btn header-item noti-icon waves-effect"
                  caret
                  tag="button"
                >
                  <i className="bx bx-customize"/>
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropdown-menu-lg" right>
                  <div className="px-lg-2">
                    <Row className="no-gutters">
                      <Col>
                        <Link className="dropdown-icon-item" to="#">
                          <img src={github} alt="Github" />
                          <span>GitHub</span>
                        </Link>
                      </Col>
                      <Col>
                        <Link className="dropdown-icon-item" to="#">
                          <img src={bitbucket} alt="bitbucket" />
                          <span>Bitbucket</span>
                        </Link>
                      </Col>
                      <Col>
                        <Link className="dropdown-icon-item" to="#">
                          <img src={dribbble} alt="dribbble" />
                          <span>Dribbble</span>
                        </Link>
                      </Col>
                    </Row>
                    <Row className="no-gutters">
                      <Col>
                        <Link className="dropdown-icon-item" to="#">
                          <img src={dropbox} alt="dropbox" />
                          <span>Dropbox</span>
                        </Link>
                      </Col>
                      <Col>
                        <Link className="dropdown-icon-item" to="#">
                          <img src={mail_chimp} alt="mail_chimp" />
                          <span>Mail Chimp</span>
                        </Link>
                      </Col>
                      <Col>
                        <Link className="dropdown-icon-item" to="#">
                          <img src={slack} alt="slack" />
                          <span>Slack</span>
                        </Link>
                      </Col>
                    </Row>
                  </div>
                </Dropdown.Menu>
              </Dropdown> */}

              <div className="dropdown d-none d-lg-inline-block ml-1">
                <button
                  type="button"
                  className="btn header-item noti-icon waves-effect"
                  onClick={this.toggleFullscreen}
                  data-toggle="fullscreen"
                >
                  <MdFullscreen className="ic_small" />
                </button>
              </div>

              {/* <NotificationDropdown /> */}

              <ProfileMenu />

              {/* <div className="dropdown d-inline-block">
                <button
                  onClick={this.toggleRightbar}
                  type="button"
                  className="btn header-item noti-icon right-bar-toggle waves-effect"
                >
                  <i className="bx bx-cog bx-spin"/>
                </button>
              </div> */}
            </div>
          </div>
        </header>
      </React.Fragment>
    );
  }
}

Header.propTypes = {
  openLeftMenuCallBack: PropTypes.func,
  t: PropTypes.any,
  //toggleRightSidebar: PropTypes.func
};

const mapStatetoProps = (state) => {
  //const { layoutType } = state.Layout
  return {};
};

export default connect(mapStatetoProps)(Header);
